<template>
	<div class="square-detail-pc-skeleton" aria-hidden="true">
		<header class="square-detail-pc-skeleton__header">
			<span class="square-detail-pc-skeleton__breadcrumb"></span>
		</header>

		<section class="square-detail-pc-skeleton__panel">
			<article class="square-detail-pc-skeleton__main">
				<span class="square-detail-pc-skeleton__media"></span>
				<span class="square-detail-pc-skeleton__title"></span>
				<span
					class="square-detail-pc-skeleton__title square-detail-pc-skeleton__title--short"
				></span>
				<span class="square-detail-pc-skeleton__meta"></span>

				<div class="square-detail-pc-skeleton__author">
					<span class="square-detail-pc-skeleton__avatar"></span>
					<span class="square-detail-pc-skeleton__name"></span>
					<span class="square-detail-pc-skeleton__follow"></span>
					<div class="square-detail-pc-skeleton__actions">
						<span></span>
						<span></span>
					</div>
				</div>

				<div class="square-detail-pc-skeleton__comments">
					<span class="square-detail-pc-skeleton__comments-title"></span>
					<span class="square-detail-pc-skeleton__comment-input"></span>
					<div v-for="item in 2" :key="item" class="square-detail-pc-skeleton__comment">
						<span></span>
						<div><i></i><i></i></div>
					</div>
				</div>
			</article>

			<aside class="square-detail-pc-skeleton__sidebar">
				<div v-for="card in 4" :key="card" class="square-detail-pc-skeleton__side-card">
					<span class="square-detail-pc-skeleton__side-cover"></span>
					<div>
						<i></i>
						<i></i>
						<i></i>
					</div>
				</div>
			</aside>
		</section>
	</div>
</template>

<style scoped>
.square-detail-pc-skeleton {
	width: 1200px;
	margin: 0 auto 150px;
}

.square-detail-pc-skeleton__header {
	display: flex;
	align-items: center;
	height: 90px;
	margin: 30px 0;
}

.square-detail-pc-skeleton span,
.square-detail-pc-skeleton i {
	display: block;
	background: linear-gradient(90deg, #eee 25%, #fafafa 42%, #eee 62%);
	background-size: 300% 100%;
	animation: square-detail-pc-shimmer 1.35s ease-in-out infinite;
}

.square-detail-pc-skeleton__breadcrumb {
	width: 260px;
	height: 22px;
	border-radius: 5px;
}

.square-detail-pc-skeleton__panel {
	display: grid;
	grid-template-columns: minmax(0, 1fr) 539px;
	align-items: start;
	gap: 21px;
	width: 1200px;
	padding: 30px;
	border-radius: 20px;
	box-shadow: 0 4px 24.6px rgba(0, 0, 0, 0.1);
	box-sizing: border-box;
}

.square-detail-pc-skeleton__main {
	min-width: 0;
}

.square-detail-pc-skeleton__media {
	width: 100%;
	aspect-ratio: 16 / 9;
	border-radius: 10px;
}

.square-detail-pc-skeleton__title {
	width: 88%;
	height: 22px;
	margin-top: 20px;
	border-radius: 5px;
}

.square-detail-pc-skeleton__title--short {
	width: 58%;
	margin-top: 11px;
}

.square-detail-pc-skeleton__meta {
	width: 150px;
	height: 14px;
	margin-top: 16px;
	border-radius: 4px;
}

.square-detail-pc-skeleton__author {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 20px 0 24px;
}

.square-detail-pc-skeleton__avatar {
	flex: 0 0 52px;
	width: 52px;
	height: 52px;
	border-radius: 50%;
}

.square-detail-pc-skeleton__name {
	width: 110px;
	height: 22px;
	border-radius: 5px;
}

.square-detail-pc-skeleton__follow {
	width: 88px;
	height: 36px;
	margin-left: 10px;
	border-radius: 8px;
}

.square-detail-pc-skeleton__actions {
	display: flex;
	gap: 12px;
	margin-left: auto;
}

.square-detail-pc-skeleton__actions span {
	width: 72px;
	height: 36px;
	border-radius: 4px;
}

.square-detail-pc-skeleton__comments {
	padding: 20px;
	border: 1px solid #efefef;
	border-radius: 12px;
}

.square-detail-pc-skeleton__comments-title {
	width: 120px;
	height: 22px;
	border-radius: 5px;
}

.square-detail-pc-skeleton__comment-input {
	width: 100%;
	height: 44px;
	margin: 16px 0 24px;
	border-radius: 22px;
}

.square-detail-pc-skeleton__comment {
	display: grid;
	grid-template-columns: 40px minmax(0, 1fr);
	gap: 12px;
	margin-top: 18px;
}

.square-detail-pc-skeleton__comment > span {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}

.square-detail-pc-skeleton__comment i {
	height: 14px;
	margin: 4px 0 12px;
	border-radius: 4px;
}

.square-detail-pc-skeleton__comment i:last-child {
	width: 72%;
}

.square-detail-pc-skeleton__side-card {
	display: grid;
	grid-template-columns: 273px minmax(0, 1fr);
	gap: 12px;
	margin-bottom: 20px;
}

.square-detail-pc-skeleton__side-cover {
	width: 273px;
	height: 153px;
	border-radius: 12px;
}

.square-detail-pc-skeleton__side-card > div {
	display: flex;
	flex-direction: column;
}

.square-detail-pc-skeleton__side-card i {
	height: 18px;
	margin-bottom: 14px;
	border-radius: 4px;
}

.square-detail-pc-skeleton__side-card i:nth-child(2) {
	width: 82%;
}

.square-detail-pc-skeleton__side-card i:last-child {
	width: 48%;
	height: 14px;
	margin-top: auto;
}

@keyframes square-detail-pc-shimmer {
	to {
		background-position: -100% 0;
	}
}
</style>
